import React, { useEffect, useState } from "react";
import { createAdminPropertyManager } from "../../api/adminData";

const inputCls =
  "w-full rounded-[8px] border border-black/10 dark:border-white/[0.08] bg-slate-100 dark:bg-[#111520] px-3 py-2 text-sm text-[#0f172a] dark:text-[#eef2ff] outline-none";

export default function CreatePropertyManagerInlineModal({ open, onClose, onSuccess }) {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (!open) return;
    setName("");
    setEmail("");
    setPhone("");
    setError("");
    setSaving(false);
  }, [open]);

  async function handleSubmit(e) {
    e.preventDefault();
    setError("");
    const n = String(name || "").trim();
    if (!n) {
      setError("Bitte einen Namen angeben.");
      return;
    }
    setSaving(true);
    try {
      const created = await createAdminPropertyManager({
        name: n,
        email: String(email || "").trim() || null,
        phone: String(phone || "").trim() || null,
        landlord_id: null,
        status: "active",
      });
      if (onSuccess) onSuccess(created);
      onClose();
    } catch (err) {
      setError(err?.message || "Bewirtschafter konnte nicht erstellt werden.");
    } finally {
      setSaving(false);
    }
  }

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[60] flex items-center justify-center bg-black/50 p-4 dark:bg-black/60"
      onClick={(e) => {
        if (e.target === e.currentTarget && !saving) onClose();
      }}
    >
      <div
        className="max-h-[90vh] w-full max-w-md overflow-y-auto rounded-[14px] border border-black/10 bg-white p-5 dark:border-white/[0.07] dark:bg-[#141824]"
        onClick={(e) => e.stopPropagation()}
      >
        <h4 className="m-0 text-base font-semibold text-[#0f172a] dark:text-[#eef2ff]">Neuer Bewirtschafter</h4>
        <p className="mt-1 mb-4 text-[11px] text-[#64748b] dark:text-[#93a4bf]">
          Wird in der Bewirtschafter-Liste gespeichert und hier ausgewählt.
        </p>
        <form onSubmit={handleSubmit} className="flex flex-col gap-3">
          <div>
            <label className="mb-1 block text-[10px] text-[#64748b] dark:text-[#6b7a9a]">Name *</label>
            <input className={inputCls} value={name} onChange={(e) => setName(e.target.value)} />
          </div>
          <div>
            <label className="mb-1 block text-[10px] text-[#64748b] dark:text-[#6b7a9a]">E-Mail (optional)</label>
            <input type="email" className={inputCls} value={email} onChange={(e) => setEmail(e.target.value)} />
          </div>
          <div>
            <label className="mb-1 block text-[10px] text-[#64748b] dark:text-[#6b7a9a]">Telefon (optional)</label>
            <input className={inputCls} value={phone} onChange={(e) => setPhone(e.target.value)} />
          </div>
          {error ? <p className="m-0 text-sm text-[#f87171]">{error}</p> : null}
          <div className="mt-2 flex justify-end gap-2">
            <button
              type="button"
              disabled={saving}
              onClick={onClose}
              className="rounded-lg border border-black/10 px-3 py-2 text-sm dark:border-white/[0.12]"
            >
              Abbrechen
            </button>
            <button
              type="submit"
              disabled={saving}
              className="rounded-lg bg-[#5b8cff] px-3 py-2 text-sm font-semibold text-white disabled:opacity-50"
            >
              {saving ? "…" : "Anlegen"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
